module.exports = __webpack_public_path__ + "img/game_bg.ca466dd3.png";